<template>
  <div>
    <gantt-chart :departmentId="managerId" />
    <content-card title="Ferienübersicht Team" cardIcon="fas fa-list">
      <template v-slot:body>
        <vacation-table
          ref="VacationOverviewTeam"
          pageSection="VacationOverviewTeam"
          v-model="selected"
        >
          <template v-slot:slot2>
            <button
              type="button"
              v-if="isExecutive"
              class="btn btn-danger mx-1"
              @click="decline()"
              :disabled="selected === undefined"
            >
              <em class="fas fa-times" />&nbsp;Ablehnen
            </button>
          </template>
        </vacation-table>
      </template>
    </content-card>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { ContentCard } from 'rey-smartmes-ui';
import VacationTable from '@/components/VacationTable.vue';
import Vacation from '@/models/Vacation';
import Logger from '@/services/Logger';
import GanttChart from '@/components/GanttChart.vue';

export default Vue.extend({
  name: 'vacation-overview-team',
  components: { ContentCard, VacationTable, GanttChart },
  data() {
    return { selected: undefined as Vacation | undefined };
  },
  computed: {
    managerId() {
      return this.isAuthenticated.profile.oid;
    },
    isExecutive(): boolean {
      return (
        this.isAuthenticated.profile.roles !== undefined &&
        this.isAuthenticated.profile.roles.length === 1 &&
        this.isAuthenticated.profile.roles[0] === 'Executive'
      );
    }
  },
  methods: {
    decline() {
      if (this.selected == undefined || !this.selected.remarkManager) {
        alert(
          'Bitte Begründung für die Ablehnung in die Spalte "Bemerkung Vorgesetzter" eintragen!'
        );
        return;
      }

      this.$reyDipApi
        .post('/api/vacationdecisions/decline', this.selected)
        .then(() => this.reloadData())
        .catch((e: Error) => Logger.error(e));
    },
    reloadData() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.VacationOverviewTeam as any).$refs.smartTable.$_SmartTable_loadElements();
      this.selected = undefined;
    }
  }
});
</script>
